<template>
  <div class="page" >
    <div class="box">
      <div class="searchBox"></div>
      <div class="vertical"></div>
      <div class="horizonta"></div>
      <input  @keyup.enter="search" class="inputBox" placeholder="请输入您要查找的小程序" ref="miniAppName"/>
      <img v-on:click="search" class="searchIcon" src="../../../assets/images/search.png"/>
      <div class="categoryList">
        <li class="categoryBtn btnSpe" @click="searchByCategory(-1)">全部</li>
        <ul class="ulList" v-for="item in typesList" :key="item.id">
          <li id="categoryBtn" class="categoryBtn" @click="searchByCategory(item.id)">{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="isLoading" v-show="isLoading">
      <img src="../../../assets/images/loading.gif"/>
    </div>
    <div class="miniAppList">
      <div class="miniAppItem" v-on:mouseover="showQrcode(item.id)" v-on:mouseout="hideQrcode()"
           v-for="item in miniAppList" :key="item.id" v-on:click="miniAppDetail(item.id)">
        <img class="headPic" :src="item.image"/>
        <span class="miniAppName">{{item.title}}</span>
        <span>{{item.author}}</span>
        <div class="mask">
          <div class="info">
            <img class="infoPic" v-show="qrcode == item.id" :src="item.codeImg"/>
          </div>
        </div>
      </div>
    </div>
    <div class="searchFailTips" v-show="show">
      <h1>抱歉，没有您要查找的小程序哦</h1>
    </div>
    <div class="loading" @click="loadMore" v-show="!allLoaded">
      <img class="loadingPic" src="../../../assets/images/loading.png"/>
    </div>
    <div v-show="allLoaded" class="endTips">
        - end -
    </div>
    <div class="toTopIcon" @click="toTop">
      <img src="../../../assets/images/top.png"/>
    </div>
  </div>
</template>

<script>
import WxShare from '@/libs/wx'
let Base64 = require('js-base64').Base64
export default {
  name: 'miniApp',
  data () {
    return {
      loading: true, // 设置一个开关来避免重负请求数据
      isLoading: false, // 数据是否正在加载
      totalElements: 0, // 初始化信息总条数
      current: 0, // 当前页码
      pageSize: 8, // 每页显示多少条
      allLoaded: false, // 全部加载完毕
      condition: null, // 查询参数，默认为null
      typesList: [], // 小程序类别
      qrcode: false,
      miniAppList: [], // 小程序列表
      show: false,
      type: -1,
      isFirstEnter: false, // 是否第一次进入，默认false
      // 微信
      requestUrl: '',
      id: '',
      encodeRequestUrl: '',
      shareTitle: '',
      shareImg: '',
      shareDesc: '',
      appid: ''

    }
  },
  methods: {
    // 小程序种类背景颜色
    randomColor: function () {
    //      let changeColor = (function () {
    //        let liList = document.getElementsByTagName('li')
    //        for (let i = 0; i < liList.length; i++) {
    //          liList[i].style.backgroundColor = '#' + Math.floor(Math.random() * 0xffffff).toString(16)
    //        }
    //      })()
    //      return changeColor
    },
    // 显示小程序二维码
    showQrcode (index) {
      this.qrcode = index
    },
    // 隐藏小程序二维码
    hideQrcode () {
      this.qrcode = 0
    },
    toTop () {
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    // 搜索小程序跳转
    search () {
    //      let that = this
    //      let title = this.$refs.miniAppName.value
    //      that.$router.push({
    //        path: '/classifyDetail',
    //        query: {title: title}
    //      })
      let that = this
      let title = this.$refs.miniAppName.value
      let condition = {}
      that.isLoading = true
      condition.where = {}
      if (title) {
        condition.where.title = {}
        condition.where.title.$like = title
      }
      condition.orderBy = {}
      condition.orderBy[1] = 'weight:desc'
      condition.orderBy[2] = 'createTime:desc'
      that.condition = Base64.encode(JSON.stringify(condition))

      let parameter = {}
      parameter.pageNumber = that.current
      parameter.pageSize = that.pageSize
      parameter.condition = that.condition
      this.$fetch(this.$api.miniapps, parameter)
        .then(function (response) {
          that.isLoading = false
          if (that.current + 1 >= response.data.totalPages) {
            that.allLoaded = true
            that.loading = false
          } else {
            that.allLoaded = false
            that.loading = true
          }
          if (response.data.totalElements === 0) {
            that.show = true
          } else {
            that.show = false
          }
          that.miniAppList = response.data.content
        })
    },
    loadMore () {
      let that = this
      let currentPage = ++that.current
      let pageSize = that.pageSize
      that.getMiniapps(currentPage, pageSize, that.condition, that.type)
    },
    bottomLoadMore () {
      let that = this
      // let resList = []
      let loading = that.loading
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 变量windowHeight是可视区的高度
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight >= scrollHeight) {
        let currentPage = ++that.current
        let pageSize = that.pageSize
        if (loading) {
          this.getMiniapps(currentPage, pageSize, that.condition, that.type)
        }
      }
    },
    // 通过类别搜索小程序
    searchByCategory (miniAppTypes) {
      let that = this
      // let type = miniAppTypes
      //      that.$router.push({
      //        path: '/classifyDetail',
      //        query: {type: miniAppTypes}
      //      })
      that.type = miniAppTypes
      that.current = 0
      let condition = {}
      condition.orderBy = {}
      condition.orderBy[1] = 'weight:desc'
      condition.orderBy[2] = 'createTime:desc'
      this.condition = Base64.encode(JSON.stringify(condition))
      that.getMiniapp(that.current, that.pageSize, that.type)
    },
    // 查看小程序详情
    miniAppDetail (id) {
      let that = this
      let miniAppid = id
      that.$router.push({
        name: 'miniAppDetail',
        query: {id: miniAppid}
      })
    },
    // 获取小程序类别列表
    getMiniapptypes () {
      let that = this
      this.$fetch(this.$api.miniapptypes + '?pageSize=100')
        .then(function (response) {
          that.typesList = response.data.content
        }).then(function () {
          that.randomColor()
        })
    },
    // 获取小程序列表
    getMiniapps (pageNumber, pageSize, type) {
      let that = this
      let parameter = {}
      let resList = []
      that.isLoading = true
      parameter.pageNumber = pageNumber
      parameter.pageSize = pageSize
      parameter.condition = that.condition
      console.log(parameter.condition)
      parameter.type = that.type
      this.$fetch(this.$api.miniapps, parameter)
        .then(function (response) {
          that.isLoading = false
          if (that.current + 1 === response.data.totalPages) {
            that.allLoaded = true
            that.loading = false
          } else {
            that.allLoaded = false
            that.loading = true
          }
          resList = response.data.content
          that.miniAppList = that.miniAppList.concat(resList)
        })
    },
    getMiniapp (pageNumber, pageSize, type) {
      let that = this
      let parameter = {}
      let resList = []
      that.isLoading = true
      parameter.type = type
      parameter.pageNumber = pageNumber
      parameter.pageSize = pageSize
      parameter.condition = that.condition
      this.$fetch(this.$api.miniapps, parameter)
        .then(function (response) {
          that.isLoading = false
          if (that.current + 1 === response.data.totalPages) {
            that.allLoaded = true
            that.loading = false
          } else {
            that.allLoaded = false
            that.loading = true
          }
          resList = response.data.content
          that.miniAppList = []
          that.miniAppList = that.miniAppList.concat(resList)
          //          console.log(response)
        })
    },
    // 获取页面数据
    getData () {
      let condition = {}
      condition.orderBy = {}
      condition.orderBy[1] = 'weight:desc'
      condition.orderBy[2] = 'createTime:desc'
      this.condition = Base64.encode(JSON.stringify(condition))
      this.getMiniapptypes()
      this.getMiniapps(this.current, this.pageSize)
    },
    wxShare () {
      let requestUrl = window.location.href
      let shareTitle = '知了小程序'
      let shareImg = 'http://www.torinosrc.com/cicadas/logo_135_135.png'
      let shareDesc = '帮你快速找到你想要的小程序'
      let encodeRequestUrl = encodeURIComponent(requestUrl)
      if (WxShare.isWeiXin()) {
        this
          .$fetch(this.$api.weixin.signature + '?url=' + encodeRequestUrl)
          .then(function (response) {
            let signature = response.data.signature
            let timestamp = response.data.timestamp
            let noncestr = response.data.noncestr
            let appid = response.data.appId
            WxShare.init(requestUrl, shareTitle, shareImg, shareDesc, signature, appid, timestamp, noncestr)
          })
          .catch(function (err) {
            console.log(err)
          })
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.bottomLoadMore) //  触发鼠标滚动事件
    this.wxShare()
  },
  created () {
    this.isFirstEnter = true
    // 只有第一次进入或者刷新页面后才会执行此钩子函数
    // 使用keep-alive后（2+次）进入不会再执行此钩子函数
    this.getData()
  },
  activated () {
    if (!this.$route.meta.isBack && !this.isFirstEnter) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      this.getData()
    }
    this.wxShare()
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false
    // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false
  },
  beforeRouteEnter (to, from, next) {
    // 路由导航钩子，此时还不能获取组件实例 `this`，所以无法在data中定义变量（利用vm除外）
    // 参考 https://router.vuejs.org/zh-cn/advanced/navigation-guards.html
    // 所以，利用路由元信息中的meta字段设置变量，方便在各个位置获取。这就是为什么在meta中定义isBack
    // 参考 https://router.vuejs.org/zh-cn/advanced/meta.html
    if (from.name === 'miniAppDetail') {
      to.meta.isBack = true
      // 判断是从哪个路由过来的，
      // 如果是page2过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
    }
    next()
  }
}
</script>
<style scoped>
  @import '../../../assets/css/miniApp/index.css';
  @import '../../../assets/css/miniApp/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/miniapp/index/index.vue